import styled from "@emotion/styled";
import { MOBILE_WIDTH } from "hooks/useDeviceType";
import { PropsWithChildren } from "react";
import { motion } from "framer-motion";

interface CardProps {
  title: string;
  color: string;
}

export const Card = ({ title, children, color }: PropsWithChildren<CardProps>) => {
  return (
    <CardContainer color={color} whileHover={{ y: -20 }}>
      <CardTitle>{title}</CardTitle>
      {children}
    </CardContainer>
  );
};

const CARD_WIDTH = 365;
const CARD_WIDTH_MOBILE = 248;
export const getCardWidth = (isMobile: boolean) => (isMobile ? CARD_WIDTH_MOBILE : CARD_WIDTH);
const CardContainer = styled(motion.div)<{ color: string }>`
  position: relative;
  overflow: hidden;
  padding: 40px;
  background: ${props => props.color};
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 36px;
  width: 365px;
  height: 500px;
  text-align: start;

  @media (max-width: ${MOBILE_WIDTH}px) {
    padding: 24px;
    width: 248px;
    height: 375px;
  }
`;

const CardTitle = styled.h5`
  color: ${props => props.theme.button.secondary.text.default};
  font-family: Quincy CF;
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 14px;
  line-height: 111%;

  @media (max-width: ${MOBILE_WIDTH}px) {
    font-size: 24px;
  }
`;
